import {
    ModelBase
} from "../base"

export class ContentModel extends ModelBase {
    id = 0;
    title = "";
    sections = [
        new ContentSectionModel()
    ]

    constructor(params) {
        super();
        this.mapModel(params);
    }
}

export class ContentSectionModel extends ModelBase {
    id = 0;
    contentId = 0;
    contentText = "";
    type = 0;
    mediaId = 0;
    description = ""
    constructor(params) {
        super();
        this.mapModel(params);
    }
}